import { NgModule } from '@angular/core';
import { Routes, RouterModule } from '@angular/router';
import { AuthGuard } from './components/auth/auth.guard';
import { DocumentosComponent } from './components/documentos/documentos.component';
import { EmpresasComponent } from './components/empresas/empresas.component';
import { LoginComponent } from './components/login/login.component';
import { ReportesComponent } from './components/reportes/reportes.component';
import { GetRoutes } from './routes/routes';

const gRoutes = new GetRoutes();

// let tempRoutes = [];

// if (gRoutes.getRoutes()) {
//   tempRoutes = gRoutes.getRoutes();
// }

const routes: Routes = [
  { path: '', redirectTo: 'login', pathMatch: 'full' },
  {
    path: 'login',
    component: LoginComponent,
  },
  {
    path: 'empresas',
    component: EmpresasComponent,
    canActivate: [AuthGuard],
  },
  {
    path: 'documentos',
    component: DocumentosComponent,
    // canActivate: [AuthGuard],
  },
  {
    path: 'reportes',
    component: ReportesComponent,
    // canActivate: [AuthGuard],
  },
  {
    path: '**',
    component: LoginComponent,
  },
];

@NgModule({
  imports: [RouterModule.forRoot(routes, { useHash: true })],
  exports: [RouterModule],
})
export class AppRoutingModule {}
